<template>
  <a class="link-item" :href="nav.path" >
    <img class="link-img" :src="IMG_URL + nav.imgUrl">
    <main class="link-title">
      <p class="label">{{ nav.label }}</p>
      <p class="name">{{ nav.name }}</p>
    </main>
  </a>
</template>

<script>
  export default {
    props: {
      nav: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .link-item {
    position: relative;
    display: inline-block;
    min-height: 3.2rem;
    .link-img {
      width: 100%;
      border-radius: px2rem(5px);
    }
    .link-title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: px2rem(16px);
      font-weight: 600;
      color: #FFF;
    }
    .label {
      border-bottom: solid 1.2px #FFF;
    }
  }
  .link-item:not(:last-child) {
    margin-bottom: px2rem(10px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Link.vue